/** Client-side gate for showing the global tool catalog UI. Server enforces via Edge Function. */
export function isGlobalCatalogAdmin(user: { email?: string } | null | undefined): boolean {
  const raw = process.env.REACT_APP_GLOBAL_CATALOG_ADMIN_EMAILS || '';
  const allowed = raw.split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
  const email = user?.email?.toLowerCase();
  return !!(email && allowed.includes(email));
}
